import SardineIcon from "src/assets/SardineIcon.svg?react";
import {
  getDefaultSardineFeedback,
  getDefaultSardineIdentityVerification,
} from "src/connections/connectionConfigs/sardine/sardineResources";
import { SardineTemplate } from "src/connections/connectionConfigs/sardine/sardineTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const SARDINE_CONFIG: ConnectionConfig<"sardine"> = {
  icon: SardineIcon,
  template: SardineTemplate,
  description: "The smartest platform for fraud prevention",
  name: "Sardine",
  resources: {
    sardine_identity_verification: {
      externalLink: null,
      integrationResource: getDefaultSardineIdentityVerification,
    },
    sardine_feedback: {
      externalLink: null,
      integrationResource: getDefaultSardineFeedback,
    },
  },
};
